import { http } from 'utils'
import { SET_TASKS } from 'vx/mutations'

const state = {
  tasks: []
}

// Tasks state getters.
const getters = {}

// Task actions
const actions = {
  /**
   * Get a logged in user's tasks.
   *
   * @return Promise
   */
  async getTasks ({ commit }) {
    commit(SET_TASKS, [])

    const response = await http.get('tasks')
    commit(SET_TASKS, response.data.data)

    return response
  }
}

// Task state mutations.
const mutations = {
  [SET_TASKS] (state, tasks) {
    state.tasks = tasks
  }
}
// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
